<template>
  <v-dialog v-model="$props.showVersionHistory" width="1000" @click:outside="$emit('close')" @keydown.esc="$emit('close')">
    <v-card v-if="!selectedVersion" elevation="5" class="rounded-lg" light>
      <v-sheet color="primary" height="70" style="flex-shrink: 0;">
        <div class="text-h5 white--text d-flex align-center pl-4" style="height: 100%; width: 100%;">
          Historique des versions
        </div>
        <v-btn
          light
          elevation="0"
          icon
          depressed
          color="white"
          large
          class="close-btn"
          @click="$emit('close')"
        >
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </v-sheet>
      <div v-if="loading">
        <v-progress-linear indeterminate color="primary" />
        <v-skeleton-loader class="mb-4" type="table-heading, table-tbody" />
        <v-skeleton-loader class="mb-4" type="table-heading, table:  button" />
      </div>
      <div v-else>
        <v-data-table
          :headers="headers"
          fixed-header
          height="500"
          :items="versions"
          :loading="loading"
          class="elevation-1 pointer"
          @click:row="loadVersion"
        >
          <template #item.versionId="{ item }">
            {{ item.authorEmail || 'Aucun auteur' }} <span class="font-weight-medium">{{ versions.findIndex(i => item.versionId === i .versionId) === 0 ? '(Actuelle)' : '' }}</span>
          </template>
          <template #item.lastModified="{ item }">
            {{ getDate(item.lastModified) }}
          </template>
          <template #item.open="{ item }">
            <v-icon>
              mdi-file-arrow-up-down-outline
            </v-icon>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <v-card v-else class="d-flex flex-column" light style="position: relative; height: 90dvh; overflow:hidden">
      <v-sheet class="d-inline-flex align-center pl-4" color="primary" height="70" style="flex-shrink: 0;">
        <v-btn
          light
          elevation="0"
          icon
          depressed
          color="white"
          large
          @click="selectedVersion = null"
        >
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
        <div class="text-h5 white--text d-flex align-center ml-2" style="height: 100%; width: 100%;">
          Vue de la Version
        </div>
      </v-sheet>
      <v-btn
        light
        elevation="0"
        icon
        depressed
        color="white"
        large
        class="close-btn"
        @click="$emit('close')"
      >
        <v-icon>
          mdi-close
        </v-icon>
      </v-btn>
      <div v-if="loading">
        <v-progress-linear indeterminate color="primary" />
        <v-skeleton-loader class="mb-4" type="table-heading, table-tbody" />
        <v-skeleton-loader class="mb-4" type="table-heading, table:  button" />
        <v-skeleton-loader class="mb-4" type="table-heading, table-tbody" />
        <v-skeleton-loader class="mb-4" type="table-heading, table:  button" />
        <v-skeleton-loader class="mb-4" type="table-heading, table-tbody" />
        <v-skeleton-loader class="mb-4" type="table-heading, table:  button" />
      </div>
      <div v-else class="overflow-scroll" style="overscroll-behavior: contain;">
        <v-card class="mx-4 mt-4" elevation="0" light outlined>
          <v-sheet color="primary" height="50" style="flex-shrink: 0;">
            <div class="text-subtitle-1 white--text d-flex align-center ml-4" style="height: 100%; width: 100%;">
              Informations
            </div>
          </v-sheet>
          <v-card-text class="d-flex flex-wrap grey lighten-4">
            <div class="col-12 d-flex flex-wrap py-0">
              <div class="col-4 py-1">
                <Label
                  :field="{viewType: 'Text', label: 'Modifié par:'}"
                  :value="content.lastUpdateUserName"
                />
              </div>

              <div class="col-5 py-1">
                <Label
                  :field="{viewType: 'Text', label: 'Email:'}"
                  :value="content.lastUpdateUserEmail"
                />
              </div>
              <div class="col-3 py-1">
                <Label
                  :field="{viewType: 'Text', label: 'Modifié à:'}"
                  :value="getDate(selectedVersion.lastModified)"
                />
              </div>
            </div>
          </v-card-text>
        </v-card>
        <component
          :is="profileComponent"
          :content="content"
          :save-customer="() => {}"
          :loading="loading"
          :disabled="true"
          :content-altered-values="contentAlteredValues"
        />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { requests } from '@/mixins/index';
import ProfileSpeedboatContact from '@/views/pages/profile/ProfileSpeedboatContact';
import ProfileLabalaguereContact from '@/views/pages/profile/ProfileLabalaguereContact';
import Label from '@/components/forms/Label.vue';

export default {
  name: 'MasterLayout',
  components: {
    ProfileSpeedboatContact,
    ProfileLabalaguereContact,
    Label
  },
  mixins: [requests],
  props: {
    uuid: {
      type: String,
      default: null
    },
    showVersionHistory: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      loading: true,
      versions: [],
      headers: [
        { text: '', value: 'open', sortable: false },
        { text: 'Modifié par:', value: 'versionId', sortable: false },
        { text: 'Date', value: 'lastModified', sortable: false }
      ],
      profileComponents: {
        crm: 'ProfileSpeedboatContact',
        crm_labalaguere: 'ProfileLabalaguereContact'
      },
      selectedVersion: null,
      content: null,
      contentAlteredValues: null,
      queryFetched: false
    };
  },
  computed: {
    profileComponent () {
      return this.profileComponents[this.$store.getters.getBrand];
    }
  },
  watch: {
    showVersionHistory () {
      if (this.$props.showVersionHistory) {
        this.fetchVersionHistory();
      }
    }
  },
  mounted () {
    if (this.showVersionHistory) {
      this.geCustomerVersions(this.uuid).then(res => {
        this.versions = res.data;
        this.loading = false;
      }).catch(err => {
        console.log(err);
      });
    }
  },
  methods: {
    fetchVersionHistory () {
      if (this.showVersionHistory && !this.queryFetched) {
        this.geCustomerVersions(this.uuid).then(res => {
          this.versions = res.data;
          this.loading = false;
          this.queryFetched = true;
        }).catch(err => {
          console.log(err);
        });
      }
    },
    loadVersion (version) {
      this.selectedVersion = version;
      this.loading = true;

      this.geCustomerVersionComparison(this.uuid, version.versionId).then(res => {
        this.content = res.data.customer;
        this.contentAlteredValues = res.data.contentAlteredValues;

        this.loading = false;
      }).catch(err => {
        console.log(err);
      });
    },
    getDate (dateValue) {
      return format(Date.parse(dateValue), 'dd MMMM y à HH:mm', { locale: fr });
    }
  }
};
</script>

<style scoped>
.close-btn{
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 5;
}

.overflow-scroll {
  overflow: scroll;
}

</style>
